export default __webpack_public_path__ + "static/media/aptdoc_kralova_logo.7e21337a.svg";